// extracted by mini-css-extract-plugin
module.exports = {"section":"VPlayer_section_19flI","button":"VPlayer_button_1cv87","icon":"VPlayer_icon_3oAES"};